import {AbstractControl, ValidatorFn} from '@angular/forms';

export function numberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        return isNaN(control.value) ? {'number': {value: control.value}} : null;
    };
}


// WEBPACK FOOTER //
// /app/src/validators/number.validator.ts